import { useEffect, useState } from "react";
import * as api from "../api";
import { aplanarMisTareas } from "../components/misTareas/pool";

// Lo que hay en Mis tareas, aplanado, para el selector unico de tarea. Null = la persona no lo ve
// (403/404, migracion pendiente, respuesta rara o fallo): el que lo use se queda con sus buscadores de
// siempre. Se guarda un minuto en memoria, tambien el null, para que abrir varias entradas seguidas (o una
// persona sin acceso) no repita la peticion.
const VIGENCIA_MS = 60000;
let cache = null;   // { t, pool }

const fresca = () => cache && Date.now() - cache.t < VIGENCIA_MS;
export const olvidarPoolMisTareas = () => { cache = null; };

export default function usePoolMisTareas(activo = true) {
  const [pool, setPool] = useState(() => (fresca() ? cache.pool : null));
  useEffect(() => {
    if (!activo) return undefined;
    if (fresca()) { setPool(cache.pool); return undefined; }
    let vivo = true;
    const guardar = p => { cache = { t: Date.now(), pool: p }; if (vivo) setPool(p); };
    try {
      api.getMisTareas()
        .then(d => guardar(d && !d.migracion_pendiente && (d.grupos || d.plan) ? aplanarMisTareas(d) : null))
        .catch(() => guardar(null));
    } catch { guardar(null); }
    return () => { vivo = false; };
  }, [activo]);
  return pool;
}
